import Vue from 'vue';
import SortDirection from './sortdirection';

export default Vue.component('sorting', {
    template:`
        <thead>
            <tr role="row">
                <th v-for="column in columns" :class="headerClass(column)" @click="sortGridData(column)">{{column.title}}</th>
            </tr>
        </thead>
    `,
    inject: [
        'performSearch'
    ],
    props:{
        columns: Array,
        queryParameters: Object
    },
    methods:{
        headerClass(column){
            if(column.sortable){
                var sortField = this.queryParameters.sortField;
                var sortDirection = this.queryParameters.sortDirection;

                if(column.sortField === sortField){
                    if(sortDirection === SortDirection.Asc){
                        return 'sorting asc';
                    } else if (sortDirection === SortDirection.Desc){
                        return 'sorting desc';
                    }
                } else {
                    return 'sorting';
                }
            } else {
                return ''
            }
        },
        setSortParameters(column){
            if(column.sortable){
                var sortField = this.queryParameters.sortField;
                var sortDirection = this.queryParameters.sortDirection;

                if(sortField !== column.sortField){
                    this.queryParameters.sortField = column.sortField;
                    this.queryParameters.sortDirection = SortDirection.Desc;
                } else if(sortDirection === SortDirection.Asc) {
                    this.queryParameters.sortDirection = SortDirection.Desc;
                } else {
                    this.queryParameters.sortDirection = SortDirection.Asc;
                }
            }
        },
        sortGridData(column){
            this.setSortParameters(column);
            this.performSearch();
        }
    }
});